var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
//TODO: figure out typing for forwardRef
import React from 'react';
import styles from './SelectSearch.module.css';
import SearchInput from '../SearchInput';
const SelectSearch = React.forwardRef((_a, ref) => {
    var { isVisible = true, 
    //@ts-ignore
    setState, sticky = false, placeholder = 'Quick search', active = true } = _a, props = __rest(_a, ["isVisible", "setState", "sticky", "placeholder", "active"]);
    return (_jsx("div", Object.assign({ ref: (node) => {
            //@ts-ignore
            ref && ref(node);
        }, className: sticky ? styles.sticky : '' }, { children: isVisible && (_jsx(SearchInput, Object.assign({ autoFocus: true, active: active, placeholder: placeholder }, props), void 0)) }), void 0));
});
// SelectSearch.propTypes = Object.assign({}, SearchInput.propTypes, {
//   isVisible: PropTypes.bool.isRequired,
//   active: PropTypes.bool,
//   onSubmit: PropTypes.func,
//   sticky: PropTypes.bool,
//   color: PropTypes.string,
//   error: PropTypes.bool,
// });
export default SelectSearch;
